export const GET_REPORTS_DASHBOARD_DATA_WATCHER =
  "app/ReportsDashboard/GET_REPORTS_DASHBOARD_DATA_WATCHER"
export const GET_REPORTS_DASHBOARD_DATA_SUCCESS =
  "app/ReportsDashboard/GET_REPORTS_DASHBOARD_DATA_SUCCESS"
export const GET_REPORTS_DASHBOARD_DATA_FAILED =
  "app/ReportsDashboard/GET_REPORTS_DASHBOARD_DATA_FAILED"
export const GET_DIVISIONS_AMBASSADOR_WATCHER =
  "app/ReportsDashboard/GET_DIVISIONS_AMBASSADOR_WATCHER"
export const GET_DIVISIONS_AMBASSADOR_SUCCESS =
  "app/ReportsDashboard/GET_DIVISIONS_AMBASSADOR_SUCCESS"
export const GET_DIVISIONS_AMBASSADOR_FAILED =
  "app/ReportsDashboard/GET_DIVISIONS_AMBASSADOR_FAILED"
export const GET_SELECTED_DIVISION_FAILED =
  "app/ReportsDashboard/GET_SELECTED_DIVISION_FAILED"
export const GET_SELECTED_DIVISION_SUCCESS =
  "app/ReportsDashboard/GET_SELECTED_DIVISION_SUCCESS"
export const GET_SELECTED_DIVISION_WATCHER =
  "app/ReportsDashboard/GET_SELECTED_DIVISION_WATCHER"
